/* eslint-disable class-methods-use-this */
import { EntityDto } from 'services/dto';
import http from '../httpService';
import { IResult } from 'models/SelectDictionary';

class DocumentService {
  public async get(entityDto: EntityDto<string>) {
    const result = await http.get('api/services/app/Document/GetDocument', {
      params: entityDto,
    });
    return result.data.result;
  }
  public async getDocumentSasUrl() {
    const result = await http.get<IResult<string>>('api/services/app/Document/GetDocumentSasUrl');
    return result.data.result;
  }
}

export default new DocumentService();
